import { AutogenLayoutCopyCommissionRate } from "./autogen/AutogenLayoutCopyCommissionRate";
import { DuplicateId, DuplicateIdProps } from "@mcleod/dispatch";

const DUPLICATE_VALIDATION_PROPS: DuplicateIdProps = {
    tableName: "commission_rate",
    screenName: "Commissions Rates",
    navigateToUrl: "lme/settlement/commissions/CommissionsRates?mode=update&key="
};

export class CopyCommissionRate extends AutogenLayoutCopyCommissionRate {
    onLoad(): void | Promise<void> {
        DuplicateId.configureIdTextbox(this.textboxRateCode, DUPLICATE_VALIDATION_PROPS);
    }
}
